var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-toolbar"},[_c('div',{staticClass:"c-toolbar-title",on:{"click":_vm.toHome}},[_vm._v("Jin")]),_c('hamburger-icon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }